import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "../../../components/display/table/gridTableCore";
import FormCore from "../../../components/display/form/formCore";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import { getTempMonitoringList } from "../../../fetch/fetchApi";
import { triggerDownloadFiles } from "@/utils/utils";
// 国际化切换语言

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class stubTempMonitoring extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOrderInfo;
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDateTime",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue: [moment(new Date()).subtract(7, "d"), moment(new Date())],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            range: 0, // 可选最小天数
            max_val: 184, // 最大可选天数
          }, // 自定义校验规则
          labelName: "最高枪温时间",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入平台订单号",
          param: {
            name: "orderId",
            type: "string",
          },
          labelName: "平台订单号",
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
            },
            {
              btnType: "button",
              text: this.internationalization.btn2, // '导出',
              handler: (e, param) => {
                this.exportData(param);
              },
            },
            {
              btnType: "reset",
              text: "重置",
            },
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        startTime: `${moment(new Date()).subtract(7, "d").format("YYYY-MM-DD HH:mm:ss")}`,
        endTime: `${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}`,
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "stubTempMonitoringTable",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "平台订单号",
            key: "orderId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备号",
            key: "stubId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "最高枪温",
            key: "temp",
            colType: "textCol",
            align: "center",
          },
          {
            name: "最高枪温时间",
            key: "time",
            colType: "textCol",
            align: "center",
            render: (value) => {
              return moment(value).format("YYYY-MM-DD HH:mm:ss");
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getTempMonitoringList,
        tableKey: "stubTempMonitoringTable",
      },
    });
  }

  fetchApi = (params) => {
    let result = {
      ...params,
    };

    if (params.date) {
      const date = params.date.split(",");
      result = {
        ...result,
        startTime: `${moment(date[0]).format("YYYY-MM-DD HH:mm:ss")}`,
        endTime: `${moment(date[1]).format("YYYY-MM-DD HH:mm:ss")}`,
      };
      delete result.date;
    }
    return result;
  };

  // 调用接口导出数据
  async exportData(param) {
    const date = param.date.split(",");
    param.startTime = `${moment(date[0]).format("YYYY-MM-DD HH:mm:ss")}`;
    param.endTime = `${moment(date[1]).format("YYYY-MM-DD HH:mm:ss")}`;
    delete param.date;
    await triggerDownloadFiles(
      "export/2",
      {
        ...param,
      },
      "枪温监控",
      "xlsx",
      "post",
    );
  }

  render() {
    return (
      <div className="sc-page-content temp-monitoring-modal">
        <div style={{ fontSize: "14px", marginBottom: "12px" }}>
          监控范围：充电过程中温度超过
          <span style={{ color: "red", fontWeight: "bold" }}>100度 </span>的全部订单
        </div>
        <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
  }
}

export default injectIntl(stubTempMonitoring);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubTempMonitoring.js